<app-header></app-header>
<div class="d-flex justify-content-center h-100 px-5">
    <div class="row  w-100 d-flex justify-content-between">
        <div class="col-lg-2 col-md-2 sidebar">
            <app-sidebar></app-sidebar>
        </div>
        <div class="col-lg-7 contentCenter col-md-7">
            <router-outlet></router-outlet>
        </div>
        <div class="col-lg-2 col-md-2 premium">
           <app-premium></app-premium>
        </div>
    </div>
</div>